module.exports = Em.View.extend({
    classNames: ['organization']
})
